/*
*  Created by SGiri 03/19/2018
*/

import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { CommonService } from "~util/common.service";
import { AuthProvider, AUTH_PROVIDERS } from "~auth/providers";
import { reduce } from 'lodash';

@Injectable()
export class BI_HttpInterceptor implements HttpInterceptor {

    providers: AuthProvider[];

    constructor(private injector: Injector, private service: CommonService) { }


    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let env = this.service.getEnvironment();
        req.headers.append('env', env);

        //const changedReq = req.clone({ headers: req.headers.append('env', env) });
        this.providers = this.providers || this.injector.get(AUTH_PROVIDERS);
        return next.handle(reduce(this.providers, (request, provider) => provider.intercept(request), req)).do(event => {
            if (event.type == 0) {
                setTimeout(() => {
                    this.service.showLoader();
                })
            } else if (event.type == 4) {
                setTimeout(() => {
                    this.service.hideLoader();
                });
            }
        }, error => {
            setTimeout(() => {
                this.service.hideLoader();
            });
        });
    }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/util/bihttp-interceptor.ts